module.exports = __webpack_public_path__ + "static/media/cteb2.50d6dd30.JPG";